import {
    BRANCH_ADD_DEVICE_BACK_URL_ACTION,
    BRANCH_MODIFY_DEVICE_BACK_URL_ACTION,
    BRANCH_VIEW_DEVICE_BACK_URL_ACTION
} from "../../../actionType";


export default function (state = {}, action) {
    switch (action.type) {
        case BRANCH_ADD_DEVICE_BACK_URL_ACTION:
            return {
                ...state,
                addDeviceBackUrl:action.backUrl,
            };
        case BRANCH_MODIFY_DEVICE_BACK_URL_ACTION:
            return {
                ...state,
                modifyDeviceBackUrl:action.backUrl,
            };
        case BRANCH_VIEW_DEVICE_BACK_URL_ACTION:
            return {
                ...state,
                viewDeviceBackUrl:action.backUrl,
            };
        default:
            return state;
    }
}
